import { useSearchParams } from '@remix-run/react'

import {
  Container,
  Stack,
  Text,
  Badge,
  Button,
  Divider,
  useMediaQuery,
  useColorModeValue,
  Box
} from '@chakra-ui/react'

import theme from '../../../../Config/theme'

import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

import ScholarshipsItem from './ScholarshipsItem';

import ScholarshipsNotFound from './ScholarshipsNotFound'

const Scholarships = ({ scholarships, pagination }) => {
  const isDesktop = useMediaQuery("(min-width: 768px)")
  const paginationBgColor = useColorModeValue('gray.100', 'gray.800')
  const borderColor = useColorModeValue(theme.borderColor.borderColorLight, theme.borderColor.borderColorDark)

  const [searchParams, setSearchParams] = useSearchParams()

  const handleNavigation = (page) => {
    searchParams.set('page', page)
    setSearchParams(searchParams)
  }

  return (
    <Container maxW={'5xl'}>
      <Stack direction={'column'} spacing={5} py={5}>
        {
          scholarships?.length === 0 && <ScholarshipsNotFound />
        }

        {
          scholarships?.map((scholarship, index) => {
            const adEvery = 5
            const canInsert = (index % adEvery) >= (adEvery - 1)

            return (
              /*
              canInsert ?
                isDesktop[0] ?
                  <Box
                    w={'728px'}
                    h={'90px'}
                    bgColor={'blue.300'}
                    lineHeight={'90x'}
                  >
                    PLACEHOLDER (DESKTOP)
                  </Box>
                  :
                  <Box
                    w={'300px'}
                    h={'250px'}
                    bgColor={'blue.300'}
                    lineHeight={'90x'}
                  >
                    PLACEHOLDER (MOBILE)
                  </Box>
                :
                */
                <ScholarshipsItem key={scholarship.id} data={scholarship} />
            )
          })

        }

        <Stack direction={'row'} justify={'center'} align={'center'} pb={10}>
          {
            scholarships.length > 0 &&
            pagination.previousButton &&
            <Button
              _hover={{ backgroundColor: theme.default.defaultColor }}
              _active={{}}
              _focus={{}}
              bgColor={paginationBgColor}
              borderRadius={'full'}
              border={'1px'}
              borderColor={borderColor}
              size={'lg'}
              leftIcon={<FaAngleLeft />}
              onClick={() => handleNavigation(pagination.currentPage - 1)}
            >
              Previous
            </Button>
          }

          {
            scholarships.length > 0 &&
            isDesktop[0] &&
            <>
              {
                pagination.buttonsRange?.map(paginationNumber => {
                  return (
                    <Button
                      _hover={{ backgroundColor: theme.default.defaultColor }}
                      _active={{}}
                      _focus={{}}
                      bgColor={pagination.currentPage === paginationNumber ? theme.default.defaultColor : paginationBgColor}
                      borderRadius={'full'}
                      border={'1px'}
                      borderColor={borderColor}
                      p={0}
                      size={'lg'}
                      onClick={() => handleNavigation(paginationNumber)}
                    >
                      {paginationNumber}
                    </Button>
                  )
                })
              }
            </>
          }

          {
            scholarships.length > 0 &&
            pagination.nextButton &&
            <Button
              _hover={{ backgroundColor: theme.default.defaultColor }}
              _active={{}}
              _focus={{}}
              bgColor={paginationBgColor}
              borderRadius={'full'}
              border={'1px'}
              borderColor={borderColor}
              size={'lg'}
              rightIcon={<FaAngleRight />}
              onClick={() => handleNavigation(pagination.currentPage + 1)}
            >
              Next
            </Button>
          }
        </Stack>

      </Stack>
    </Container >
  )
}

export default Scholarships